import { SingleSelectDropdown } from '../Dropdowns/SingleSelectDropdown';
import {
  MultiSelectCustomAttribute,
  SelectCustomAttribute,
} from '../../sdk/types/common/customAttribute';
import { mapCustomAttributeOptions } from './helpers';

export type SelectAttributeInputProps = {
  attribute: SelectCustomAttribute | MultiSelectCustomAttribute;
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
  placeholder?: string;
  clearable?: boolean;
  isOpen?: boolean;
  onClose?: () => void;
  error?: boolean;
  ['data-testid']?: string;
};

/**
 * Layer A primitive: single-select dropdown for select-typed custom attributes.
 * Exposes `isOpen`/`onClose` pass-through props so consumers (e.g. Preview's
 * `InlineEdit`) can implement save-on-close patterns without forking the
 * component.
 *
 * Accepts both `SelectCustomAttribute` and `MultiSelectCustomAttribute` because
 * inline-edit flows in app code sometimes render a single-select picker on top
 * of a multi-select attribute (e.g. picking a single option from a multi-list).
 */
export const SelectAttributeInput = ({
  attribute,
  value,
  onChange,
  disabled,
  placeholder,
  clearable = true,
  isOpen,
  onClose,
  error,
  'data-testid': dataTestId,
}: SelectAttributeInputProps) => {
  const options = mapCustomAttributeOptions(attribute);

  return (
    <SingleSelectDropdown
      options={options}
      value={value || null}
      onChange={(selected) => onChange(selected ? String(selected) : '')}
      disabled={disabled}
      placeholder={placeholder}
      clearable={clearable}
      isOpen={isOpen}
      onClose={onClose}
      error={error}
      data-testid={dataTestId ?? `custom-attr-${attribute.id}`}
    />
  );
};
